import * as React from "react";

function Message({width=24,height=24,...props}) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4a8 8 0 00-6.58 12.55c.295.428.367.998.132 1.503L4.647 20H12a8 8 0 100-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10H3.862a1.5 1.5 0 01-1.328-2.198l1.088-2.34A9.958 9.958 0 012 12z"
        fill="var(--color-blue-500)"
      />
    </svg>
  );
}

export default Message;
